import { Divider } from "antd"
import { ZoomFactor } from "./ZoomFactor/ZoomFactor"
import { Graph } from "@antv/x6"

export function FooterRight({ graph }: { graph?: Graph }) {
  const onZoomChange = (value: number) => {
    graph?.zoomTo(Number((value / 100).toFixed(2)))
  }
  return <div className="flex-end pr-1">
    <Divider type="vertical" />
    <ZoomFactor graph={graph} onChange={onZoomChange} />
    <Divider type="vertical" />
  </div>
}